function epicAccountProductSlider () {
  Shopify.theme.jsEpicAccountProductSlider = {
    init: function init(slider) {
      if (slider) {
        this.initSlider(slider);
      } else {
        const sliders = document.querySelectorAll('.epic-account-product-slider');
        sliders.forEach(slider => this.initSlider(slider));
      }
    },
    initSlider: function initSlider(slider) {
      if (!slider) return;
      const sliderGallery = slider.querySelector('.slider-gallery');
      if (!sliderGallery) return;
      const slidesCount = parseInt(slider.getAttribute('data-products-per-slide')) || 5;
      const dots = slider.getAttribute('data-dots') == 'false' ? false : true;
      const wrapAround = slider.getAttribute('data-wrap-arround') == 'true' ? true : false;
      const options = {
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: false,
        draggable: true,
        cellAlign: 'left',
        wrapAround: wrapAround,
        pageDots: dots,
        contain: true,
        groupCells: slidesCount,
        prevNextButtons: true,
        adaptiveHeight: true,
        initialIndex: 0,
        arrowShape: 'M64.44,83.92a2,2,0,0,0-.47-.78L30.83,50,64,16.86a2,2,0,0,0,.47-.78l9.81-9.66a2,2,0,1,0-2.81-2.84l-45.69,45a2,2,0,0,0,0,2.84l45.69,45a2,2,0,1,0,2.81-2.84Z'
      };
      const isMediumScreen = window.matchMedia('(max-width: 989px)').matches;

      if (isMediumScreen) {
        options.groupCells = 2;
      }

      slider.dataset.flickityOptions = JSON.stringify(options);
      this.initFlickity(slider, options);
      this.handleResize(slider);
    },
    initFlickity: function initFlickity(slider, options) {
      const sliderGallery = slider.querySelector('.slider-gallery');
      const existingInstance = slider.dataset.flickityInstance;

      if (existingInstance) {
        const flickityInstance = window.Flickity.data(sliderGallery);
        flickityInstance === null || flickityInstance === void 0 ? void 0 : flickityInstance.destroy();
        delete slider.dataset.flickityInstance;
      }

      const sliderInit = new window.Flickity(sliderGallery, options);
      slider.dataset.flickityInstance = sliderInit;
    },
    handleResize: function handleResize(slider) {
      window.addEventListener('resize', () => {
        const options = JSON.parse(slider.dataset.flickityOptions);
        const isMediumScreen = window.matchMedia('(max-width: 989px)').matches;

        if (isMediumScreen) {
          options.groupCells = 2;
        } else {
          options.groupCells = parseInt(slider.getAttribute('data-products-per-slide')) || 5;
        }

        slider.dataset.flickityOptions = JSON.stringify(options);
        this.initFlickity(slider, options);
      });
    },
    destroySlider: function destroySlider(slider) {
      const sliderGallery = slider.querySelector('.slider-gallery');

      if (sliderGallery) {
        const flickityInstance = window.Flickity.data(sliderGallery);

        if (flickityInstance) {
          flickityInstance.destroy();
          delete slider.dataset.flickityInstance;
        }
      }
    }
  };
  Shopify.theme.jsEpicAccountProductSlider.init();
}

export { epicAccountProductSlider as default };
